import template from './productsListHomeLoan.template.html';

export default {
  template,
  bindings: {
    lenders: '<',
    documents: '<',
    products: '<',
    chosenProducts: '<',
    loanAmount: '<',
    isSplitSearch: '<',
    isLoadingFinished: '<',
    onSelected: '&',
    onLoadMore: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdMedia, helperService, listServiceNew, uiService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentCurrency = null;
      ctrl.currentDateFormat = null;
      ctrl.organizationCountry = '';
      ctrl.lowestCostProduct = null;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();
      ctrl.idHighlightedLenders = [];

      const vowIdLenders = ['48e3d546cc6279dadae4ab3dace3ecd661cff2e1e6c2d79eddea12ff017503a6'];

      const yntIdLenders = [
        'a422e5e5a235a545d128c0f698e9cebe40b78cc484bf254046cd3421262e9de9',
        '48e3d546cc6279dadae4ab3dace3ecd661cff2e1e6c2d79eddea12ff017503a6'
      ];

      ctrl.initialize = ({ isInitialized }) => {
        if (isInitialized) {
          ctrl.isDev = $rootScope.isDev();
          ctrl.isYnt = $rootScope.isYnt();
          ctrl.isVow = $rootScope.isVow();
          ctrl.organizationCountry = helperService.getOrganizationCountry();
          ctrl.currentCurrency = $rootScope.CurrentCurrency();
          ctrl.currentDateFormat = $rootScope.CurrentDateFormat();
          ctrl.setHighlightedIdLenders();
          ctrl.lenders = ctrl.lenders || [];
          ctrl.documents = ctrl.documents || [];
          ctrl.products = ctrl.products || [];
          ctrl.chosenProducts = ctrl.chosenProducts || [];
          ctrl.loanAmount = ctrl.loanAmount || 0;
          ctrl.isSplitSearch = ctrl.isSplitSearch || false;
          ctrl.isLoadingFinished = ctrl.isLoadingFinished || false;
          ctrl.isLoadMore = false;
          ctrl.onReady({ list: ctrl.list });
          ctrl.list.setOrderBy('getHomeLoanTotalCosts()');
          ctrl.list.setData(ctrl.products);
        } else {
          ctrl.list.setDataAppend(ctrl.products);
          ctrl.isLoadMore = false;
        }
        ctrl.getLowestCost();
        ctrl.canScroll = ctrl.isLoadingFinished;
      };

      ctrl.setHighlightedIdLenders = () => {
        if (ctrl.isDev || ctrl.isYnt) {
          ctrl.idHighlightedLenders = yntIdLenders;
        }
        if (ctrl.isVow) {
          ctrl.idHighlightedLenders = vowIdLenders;
        }
      };

      ctrl.isHighlighted = (idLender) => _.indexOf(ctrl.idHighlightedLenders, idLender) > -1;

      ctrl.getLowestCost = () => {
        ctrl.lowestCostProduct = _.minBy(
          ctrl.list.getData() || [],
          (item) => item?.homeLoanEstimate[0]?.product?.totalCosts
        );
      };

      ctrl.select = (data) => {
        ctrl.list.setSelected(data);
        if (ctrl.isSplitSearch) {
          ctrl.onSelected({ data });
        } else if (ctrl.chosenProducts.length <= 4) {
          ctrl.onSelected({ data });
        } else {
          uiService.toast({
            text: {
              p1: 'Four products',
              p2: 'are maximum',
              p3: 'for compare'
            },
            warn: true
          });
        }
      };

      ctrl.productsLoadMore = () => {
        if (ctrl.canScroll) {
          ctrl.onLoadMore();
        }
        ctrl.isLoadMore = ctrl.isLoadingFinished;
        ctrl.canScroll = false;
      };

      ctrl.getLender = (idLender) => {
        const lender = _.find(ctrl.lenders || [], (l) => l?.id === idLender);
        return lender || 'N/A';
      };

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d?.lender[0]?.id === idLender && _.indexOf(d?.type, 'LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.getLastDateModified = (dateString) => {
        if (dateString && _.isString(dateString)) {
          const dateObj = new Date(dateString);
          return moment(dateObj).format(ctrl.currentDateFormat);
        }
        return '-';
      };

      ctrl.$onInit = () => {
        ctrl.initialize({ isInitialized: true });
      };

      ctrl.$onChanges = (changes) => {
        if (
          changes?.products &&
          !_.isEmpty(changes?.products?.previousValue) &&
          changes?.products?.currentValue
        ) {
          ctrl.initialize({ isInitialized: false });
        }
      };
    }
  }
};
